import {
  GET_NEWS,
  GET_NEWS_SUCCESS,
  GET_NEWS_FAIL,
  ADD_NEWS,
  ADD_NEWS_SUCCESS,
  ADD_NEWS_FAIL,
  UPDATE_NEWS,
  UPDATE_NEWS_SUCCESS,
  UPDATE_NEWS_FAIL,
  DELETE_NEWS,
  DELETE_NEWS_SUCCESS,
  DELETE_NEWS_FAIL,
  GET_COMMENTS,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAIL,
  ADD_COMMENTS,
  ADD_COMMENTS_SUCCESS,
  ADD_COMMENTS_FAIL,
  GET_COMMENTS_CYCLE_RENEW,
  GET_COMMENTS_CYCLE_RENEW_SUCCESS,
  GET_COMMENTS_CYCLE_RENEW_FAIL,
  ADD_COMMENTS_CYCLE_RENEW,
  ADD_COMMENTS_CYCLE_RENEW_SUCCESS,
  ADD_COMMENTS_CYCLE_RENEW_FAIL,
} from "./actionTypes";

export const getNews = (id) => ({
  type: GET_NEWS,
  payload: id,
});

export const getNewsSuccess = (news) => {
  // console.log("News response in success action:", news);
  return {
    type: GET_NEWS_SUCCESS,
    payload: news,
  };
};

export const getNewsFail = (error) => {
  // console.log("Error response in fail action:", error);
  return {
    type: GET_NEWS_FAIL,
    payload: error,
  };
};

export const addNews = (news) => ({
  type: ADD_NEWS,
  payload: news,
});

export const addNewsSuccess = (news) => ({
  type: ADD_NEWS_SUCCESS,
  payload: news,
});

export const addNewsFail = (error) => ({
  type: ADD_NEWS_FAIL,
  payload: error,
});
export const updateNews = (news) => ({
  type: UPDATE_NEWS,
  payload: news,
});

export const updateNewsSuccess = (news) => ({
  type: UPDATE_NEWS_SUCCESS,
  payload: news,
});

export const updateNewsFail = (error) => ({
  type: UPDATE_NEWS_FAIL,
  payload: error,
});
/////////////////////////////
export const deleteNews = (news) => ({
  type: DELETE_NEWS,
  payload: news,
});

export const deleteNewsSuccess = (id) => ({
  type: DELETE_NEWS_SUCCESS,
  payload: id,
});

export const deleteNewsFail = (error) => ({
  type: DELETE_NEWS_FAIL,
  payload: error,
});
export const getComments = (id) => ({
  type: GET_COMMENTS,
  payload: id,
});

export const getCommentsSuccess = (news) => {
  // console.log("News response in success action:", news);
  return {
    type: GET_COMMENTS_SUCCESS,
    payload: news,
  };
};

export const getCommentsFail = (error) => {
  // console.log("Error response in fail action:", error);
  return {
    type: GET_COMMENTS_FAIL,
    payload: error,
  };
};

export const addComments = (news) => ({
  type: ADD_COMMENTS,
  payload: news,
});

export const addCommentsSuccess = (news) => ({
  type: ADD_COMMENTS_SUCCESS,
  payload: news,
});

export const addCommentsFail = (error) => ({
  type: ADD_COMMENTS_FAIL,
  payload: error,
});

export const getCommentscyclerenew = (id) => ({
  type: GET_COMMENTS_CYCLE_RENEW,
  payload: id,
});

export const getCommentscyclerenewSuccess = (news) => {
  // console.log("News response in success action:", news);
  return {
    type: GET_COMMENTS_CYCLE_RENEW_SUCCESS,
    payload: news,
  };
};

export const getCommentscyclerenewFail = (error) => {
  // console.log("Error response in fail action:", error);
  return {
    type: GET_COMMENTS_CYCLE_RENEW_FAIL,
    payload: error,
  };
};

export const addCommentscyclerenew = (data, resolve, reject) => ({
  type: ADD_COMMENTS_CYCLE_RENEW,
  payload: data,
  resolve, // optional callback for saga
  reject, // optional callback for saga
});

export const addCommentscyclerenewSuccess = (news) => ({
  type: ADD_COMMENTS_CYCLE_RENEW_SUCCESS,
  payload: news,
});

export const addCommentscyclerenewFail = (error) => ({
  type: ADD_COMMENTS_CYCLE_RENEW_FAIL,
  payload: error,
});
